import { INodes } from 'services/types';

export const getNodes = <T extends { id: any }>(data?: T[]): INodes<T> => ({
  nodes: data ?? [],
});
